module.exports = __webpack_public_path__ + "static/img/10027.303dcfd0.png";